import { atom } from 'jotai'
import { selectAtom } from 'jotai/utils'
import { ConversationTurnState } from '../../model/StatsAssistant'

export const IDLE_TURN_STATE: ConversationTurnState = {
  isProcessing: false,
  progressText: null,
  error: null,
  failedRequest: null,
}

/** Tours en cours par ulid de conversation : plusieurs peuvent tourner en arrière-plan. */
export const statsAssistantTurnsAtom = atom<Record<string, ConversationTurnState>>({})

const isSameUlidList = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((ulid, index) => ulid === b[index])

/** Conversations en cours d'analyse. Stable entre deux events : ne re-rend pas l'historique à chaque progression. */
export const statsAssistantProcessingUlidsAtom = selectAtom(
  statsAssistantTurnsAtom,
  (turns) => Object.keys(turns).filter((ulid) => turns[ulid].isProcessing),
  isSameUlidList,
)

export const statsAssistantHasProcessingTurnAtom = atom(
  (get) => get(statsAssistantProcessingUlidsAtom).length > 0,
)
